import React from 'react';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-24 bg-gray-50 px-4 text-center" data-id="element-12">
      <div className="max-w-2xl mx-auto" data-id="element-13">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-14">
          Si hoy estás cansada de prometerte "mañana practico"…
        </h2>
        <p className="text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-15">
          Hazlo fácil: descarga el kit, elige tu primer guion, y usa una frase
          rescate esta semana.
        </p>

        <div className="flex justify-center" data-id="element-16">
          <Button variant="primary" size="lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-17">
            Quiero mi Kit 🔥
          </Button>
        </div>

        <p className="mt-8 text-gray-400 text-sm" data-id="element-18">
          Inglés Sin Pena (7 días) — para hablar aunque te dé pena.
        </p>
      </div>
    </section>;
}